// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3MC1B","large":"styles_large__z4xc3"};